import styled from 'styled-components';

const StyledMenuIndustries = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100vh;
  padding-top: 150px;
  z-index: 3;
  opacity: 0;
  transition: opacity .5s ease-out;
  background-color: #fff;
  pointer-events: none;
  &.show{
    opacity: 1;
    pointer-events: all;
  }
  .wrapper--flex{
    position: relative;
    padding: 0 64px 140px;
    display: flex;
    flex-flow: row wrap;
  }
  h3{
    opacity: 0;
    transition: all .15s ease-out ;
    line-height: 120% !important;
    cursor: pointer;

  }
  &.show h3{
    opacity: 1;
  }
  .gradient-fashion{
    background: linear-gradient(105.88deg, rgba(218, 96, 124, 1), rgba(232, 162, 178, 1) );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    text-align:center;
    transition: color .2s ease-in-out, opacity .5s .1s;
  }
  .gradient-real{
    background: linear-gradient(105.88deg, rgba(215, 48, 50, 1), rgba(244, 160, 127, 1));
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    text-align:center;
    transition: color .2s ease-in-out, opacity .5s .2s;
  }
  .gradient-interior{
    background: linear-gradient(105.88deg, #1A60D0, #B9D0E4 );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    text-align:center;
    transition: color .2s ease-in-out, opacity .5s .3s;
  }
  .gradient-cpg{
    background: linear-gradient(105.88deg, #E2B234 , #F4DD63 );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    text-align:center;
    transition: color .2s ease-in-out, opacity .5s .4s;;
  }
  .gradient-more{
    background: linear-gradient(105.88deg, #7244E2 , #C8B5F8 );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    text-align:center;
    transition: color .2s ease-in-out, opacity .5s .5s;
  }
  h3:hover{
    color:rgba(0,0,0,0);
  }
  @media screen and (min-width: 1440px){
    h3:nth-child(1), h3:nth-child(3){
      padding-right: 80px;
    }
  }
  @media screen and (min-width: 1835px){
    h3:nth-child(4){
      padding-right: 80px;
    }
  }
  @media screen and (min-width: 1024px){
    h3:nth-child(1), h3:nth-child(3){
      padding-right: 64px;
    }
  }
  @media screen and (max-width: 1023px){
    position: relative;
    height: auto;
    padding-top: 48px;
    .row--mobile{
      padding: 0 40px;
    }
    .md--title{
      padding-right: 24px;
    }
    .md--title::after{
      content: '';
      position: relative;
      margin-left: 10px;
      border-radius: 50%;
      width: 8px;
      height: 8px;
      display: inline-block;
    }
    .md--title.gradient-fashion::after{
      background: #DA607C;
    }
    .md--title.gradient-real::after{
      background: #D73032;
    }
    .md--title.gradient-interior::after{
      background:#1A60D0;
    }
    .md--title.gradient-cpg::after{
      background: #E2B234;
    }
    .md--title.gradient-more::after{
      background: #7244E2;
    }
  }
  @media screen and (max-width: 767px){
    padding-top: 0;
    .row--mobile{
      display: none;
    }
    .wrapper--flex{
      flex-flow: column wrap;
    }
    .md--title{
      font-size: 35px;
      text-align: left;
      margin-bottom: 16px;
      flex: 1 1 100%;
    }
  }
  
`;

export {
  StyledMenuIndustries,
};

